import { j as c } from "./jsx-runtime-C5mzlN2N.js";
import d from "styled-components";
import { forwardRef as h } from "react";
import { t as m, a as $, b as g, c as f } from "./styles-DaQVIHg4.js";
const x = d.span`
  ${(t) => t.$variant === "text" ? m[t.$size] : $[t.$size]}
  
  ${(t) => g[t.$weight]};
  
  ${(t) => f.colors[t.$color]};

  &[data-is-truncated="true"] {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &[data-as="span"] {
    display: block;
  }
`, v = h((t, e) => {
  const {
    variant: s = "text",
    size: r = "md",
    weight: o = "regular",
    color: i = "primary",
    as: a = "span",
    className: p,
    isTruncated: l = !1,
    children: y,
    ...n
  } = t;
  return /* @__PURE__ */ c.jsx(
    x,
    {
      ...n,
      ref: e,
      className: p,
      as: a,
      $variant: s,
      $size: r,
      $weight: o,
      $color: i,
      "data-is-truncated": l,
      "data-as": a,
      children: y
    }
  );
});
export {
  v as T
};
